import { IOBuffer } from 'iobuffer';
/**
 * Parses a single `PageTextsN` stream from a UVProbe OLE file.
 * @param content - raw stream bytes.
 * @returns The section title and its key/value properties.
 */
export function parsePageText(content) {
    const buffer = new IOBuffer(content);
    buffer.readUint32(); // unknown flag (always 1 in observed files)
    buffer.readUint32(); // page index
    const title = readDotNetString(buffer).replace(/^\[(?<inner>.*)\]$/, '$<inner>');
    const count = buffer.readUint32();
    const properties = {};
    for (let i = 0; i < count; i++) {
        const key = readDotNetString(buffer).replace(/:\s*$/, '');
        properties[key] = readDotNetString(buffer);
    }
    return { title, properties };
}
/**
 * Reads a .NET `BinaryWriter` string: a 7-bit-encoded length prefix followed by
 * that many latin1 bytes.
 * @param buffer - the buffer positioned at the length prefix.
 * @returns The decoded string.
 */
function readDotNetString(buffer) {
    return buffer.decodeText(read7BitLength(buffer), 'latin1');
}
/**
 * Reads a .NET 7-bit-encoded (LEB128-style) length prefix.
 * @param buffer - the buffer positioned at the length prefix.
 * @returns The decoded length.
 */
function read7BitLength(buffer) {
    let result = 0;
    let shift = 0;
    let byte;
    do {
        byte = buffer.readUint8();
        result |= (byte & 0x7f) << shift;
        shift += 7;
    } while ((byte & 0x80) !== 0);
    return result;
}
//# sourceMappingURL=pageTexts.js.map